import { LoadingOverlay, Select, Table } from '@mantine/core';
import classes from './styles.module.css';
import { useTranslation } from 'react-i18next';
import {
  CommonSettingType,
  LevelUserPriority,
  SaveSettingsParams,
  UserActionPriority
} from '@/services/api/settingsApiArea/types';
import { useState } from 'react';
import { commonSettingsApiArea } from '@/services/api/settingsApiArea';
import useEventsTrailSlice from '@/store/homeWidget/useEventsTrailSlice';
import { IconChevronDown } from '@tabler/icons';
import { useClickOutside, useDisclosure } from '@mantine/hooks';
import { createStyles } from '@mantine/emotion';

interface Props {
  element: UserActionPriority;
}

export function RowItem(props: Props) {
  const { element } = props;
  const { t } = useTranslation();
  const useCX = createStyles({});
  const { cx } = useCX();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dropdownOpened, { toggle, close }] = useDisclosure();
  const { LoadEventsWithOutLoadingStatus } = useEventsTrailSlice().actions;

  const [commonSettings] = useEventsTrailSlice().useEvents().useState();
  const ref = useClickOutside(() => dropdownOpened && close());
  const priorityOptions = Object.entries(LevelUserPriority)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .filter(([_key, value]) => typeof value === 'number')
    .map(([key, value]) => ({
      value: String(value),
      label: t(`filials.settings.priority.${key}`)
    }));

  const propsValue = priorityOptions?.find((el) => el.value === element.Level.toString())?.value;

  const [value, setValue] = useState<string | undefined>(
    propsValue ? String(propsValue) : undefined
  );

  const handleChange = (Level: string | null) => {
    if (!commonSettings || !Level) {
      return;
    }

    setValue(Level);
    setIsLoading(true);
    let priorityToChange: UserActionPriority | undefined = commonSettings.UserActionPriority.find(
      (e) => e.Id === element.Id
    );

    if (!priorityToChange) {
      return;
    }

    priorityToChange = {
      ...element,
      Level: Number(Level)
    };
    const params: SaveSettingsParams = {
      Type: CommonSettingType.UserActionPriority,
      Data: {
        UserActionPriority: [priorityToChange]
      }
    };

    commonSettingsApiArea()
      .SaveSettings(params)
      .then(LoadEventsWithOutLoadingStatus)
      .finally(() => setIsLoading(false));
  };

  const currentValue = priorityOptions.find((i) => value === i.value.toString())?.label;

  return (
    <Table.Tr style={{ position: 'relative' }}>
      <Table.Td className={classes.tableCell} w="300px">
        <div className={classes.events}>{element.TypeName}</div>
      </Table.Td>
      <Table.Td className={classes.tableCell} w="150px">
        <div className={classes.module}>{element.ModuleName}</div>
      </Table.Td>
      <Table.Td className={cx(classes.tableCell)} w="300px" ref={ref}>
        <div className={classes.statusHandler} onClick={toggle}>
          {currentValue}

          <IconChevronDown className={classes.arrow} size="1rem" color="#98A2B3" />
        </div>
        <Select
          value={value}
          dropdownOpened={dropdownOpened}
          rightSection={<IconChevronDown size="1rem" color="#98A2B3" />}
          onChange={handleChange}
          className={classes.select}
          data={priorityOptions}
          comboboxProps={{
            transitionProps: { transition: 'pop', duration: 200 },
            offset: -20
          }}
        />
        <LoadingOverlay visible={isLoading} style={{ position: 'absolute' }} />
      </Table.Td>
    </Table.Tr>
  );
}
